<!-- #region Parte de arriba en móvil -->
<div class="justify_content_space_between align_items_center margin_bottom_large h_padding_very_small only_lt_sm">
	<h3 class="fw500">{{ totalAmountOfProducts }} resultados</h3>

	<div class="div_mobile_filters_toggle align_items_center">
		<p class="fw500">Filtros</p>
		<button mat-icon-button class="square" (click)="bCardToggle = !bCardToggle">
			<mat-icon>tune</mat-icon>
		</button>
	</div>
</div>
<!-- #endregion -->

<mat-card class="pink_shadow relative overflow_hidden" @verticalExpansionSlower *ngIf="bCardToggle">
	<mat-card-content>
		<div class="align_items_center gap_small margin_bottom_small">
			<h3 class="montserrat_700" autofocus tabindex="0">Filtros</h3>
			<a class="a_clear_filters body2 color_accent_500" (click)="clearAllFilters()" (keydown.enter)="clearAllFilters()" tabindex="0" role="button">Limpiar Filtros</a>
		</div>

		<div tabindex="0" [attr.aria-label]="'Filtros activos, '+ activeFilters.length" role="listbox" #activeFiltersContainer>
			<mat-chip-listbox class="margin_bottom_small" *ngIf="activeFilters.length">
				<mat-chip *ngIf="searchInput" matTooltip="Quitar" class="bg_accent_50 pointer" (click)="clearSearchInput()" (keydown.enter)="clearSearchInput()" tabindex="0" role="listitem">
					"{{ searchInput }}"
					<mat-icon>close</mat-icon>
				</mat-chip>
				<ng-container *ngFor="let af of activeFilters">
					<mat-chip matTooltip="Quitar" class="bg_accent_50 pointer" (click)="onRemoveFilter(af)" (keydown.enter)="onRemoveFilter(af)" *ngIf="af.group_id != eProductFilterGroupType.STORES" tabindex="0" role="listitem">	<!-- No muestro el chip del store porque el filtrado por store solo se hace en la vista de store, donde ya está la cabecera con el avatar y el nombre-->
						<ng-container *ngIf="af.type != eProductFilterType.RANGE_INPUT; else priceRange">
							{{ af.title }}
						</ng-container>
						<ng-template #priceRange>
							<ng-container *ngIf="af.group_id == eProductFilterGroupType.PRICES">
								<span class="color_black_medium_emphasis">$</span>
								{{ af.extra[0].min}}
								<span class="color_black_medium_emphasis">&nbsp;hasta $</span>
								{{ af.extra[0].max}}
							</ng-container>
							<ng-container *ngIf="af.group_id == eProductFilterGroupType.DISCOUNTS">
								<span class="color_black_medium_emphasis">-%</span>
								{{ af.extra[0].min}}
								<span class="color_black_medium_emphasis">&nbsp;hasta -%</span>
								{{ af.extra[0].max}}
							</ng-container>
						</ng-template>
						<mat-icon>close</mat-icon>
					</mat-chip>
				</ng-container>
			</mat-chip-listbox>
		</div>

		<div class="margin_bottom_medium">
			<app-contained-progress-bar [show]="bLoading"></app-contained-progress-bar>
			<hr class="subtle margin0" [ngClass]="{hide: bLoading}">
		</div>

		<div class="margin_bottom_medium overflow_hidden" *ngFor="let filterGroup of filtersGroups">

			<h4 class="montserrat_700 margin_bottom_small" tabindex="0" [attr.aria-label]="'Filtros disponibles: '+ filterGroup.title" [attr.role]="(filterGroup.id == eProductFilterGroupType.PRICES || filterGroup.id == eProductFilterGroupType.DISCOUNTS) ? 'form' : 'listbox'">{{ filterGroup.title }}</h4>

			<ng-container *ngIf="filterGroup.id != eProductFilterGroupType.PRICES && filterGroup.id != eProductFilterGroupType.DISCOUNTS; else ranges">

				<!-- #region Filtros que son listas -->
				<ng-container *ngFor="let opt of filterGroup.options">
					<a class="a_filter_caption body2 color_black_inactive flex gap_very_small" *ngIf="opt.value" (click)="onClickFilter(opt)" (keydown.enter)="onClickFilter(opt)" tabindex="0" role="listitem">
						<ng-container *ngIf="filterGroup.id == eProductFilterGroupType.VALUABLES">
							<img class="value_icon pointer" [src]="companyValues[opt.id-1].imgSrcBlue" aria-hidden="true">
						</ng-container>
						{{ opt.title }} ({{ opt.value }})
					</a>
				</ng-container>
				<!-- #endregion -->

			</ng-container>

			<ng-template #ranges>

				<!-- #region Formulario de precio -->
				<ng-container *ngIf="filterGroup.id == eProductFilterGroupType.PRICES">
					<form [formGroup]="priceRangeFg" (submit)="onMinMaxFilter(filterGroup.options[0], priceRangeFg)" class="flex gap_very_small">
						<div class="flex1 flex gap_very_small">
							<mat-form-field class="no_vertical_spacing body2">
								<input matInput formControlName="min" placeholder="Min" [errorStateMatcher]="minMaxErrorStateMatcher"/>
							</mat-form-field>
							<mat-form-field class="no_vertical_spacing body2">
								<input matInput formControlName="max" placeholder="Max" [errorStateMatcher]="minMaxErrorStateMatcher"/>
							</mat-form-field>
						</div>
						<button mat-icon-button color="primary" [disabled]="!priceRangeFg.get('min')!.value || !priceRangeFg.get('max')!.value" [attr.aria-label]="'Confirmar filtro de '+ filterGroup.title" [attr.aria-valuemin]="priceRangeFg.get('min')!.value" [attr.aria-valuemax]="priceRangeFg.get('max')!.value">
							<mat-icon>search</mat-icon>
						</button>
					</form>
				</ng-container>
				<!-- #endregion -->

				<!-- #region Formulario de descuento -->
				<ng-container *ngIf="filterGroup.id == eProductFilterGroupType.DISCOUNTS">
					<form [formGroup]="discountRangeFg" (submit)="onMinMaxFilter(filterGroup.options[0], discountRangeFg)" class="flex gap_very_small">
						<div class="flex1 flex gap_very_small">
							<mat-form-field class="no_vertical_spacing body2">
								<input matInput formControlName="min" placeholder="Min" [errorStateMatcher]="minMaxErrorStateMatcher"/>
							</mat-form-field>
							<mat-form-field class="no_vertical_spacing body2">
								<input matInput formControlName="max" placeholder="Max" [errorStateMatcher]="minMaxErrorStateMatcher"/>
							</mat-form-field>
						</div>
						<button mat-icon-button color="primary" [disabled]="discountRangeFg.invalid">
							<mat-icon>search</mat-icon>
						</button>
					</form>
				</ng-container>
				<!-- #endregion -->

			</ng-template>

		</div>

	</mat-card-content>
</mat-card>